import { AquariusBadge } from "@smartrr/shared/customerPortal/components/AquariusBadge";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React from "react";
import styled from "styled-components";

const StyledBadge = styled(AquariusBadge)`
  & {
    border-radius: 8px;
    padding: 5px;
    max-height: 100px;
    height: 40px;
  }

  span {
    overflow: visible;
    text-overflow: unset;
    text-align: center;
    white-space: normal;
    padding: 0;
    line-height: 15px;
  }

  @media (min-width: 600px) {
    padding: 0;
    padding-left: 0;
    padding-right: 0;
  }
`;

export const SubscriberOnlyBadge = () => <StyledBadge label={typedLocalize("loyalty.subscriberOnly")} />;
